export default {
	init() {

		var container = document.querySelectorAll('.fullscreenSlider');

		if( container.length!=0 ) {

			function FullscreenSlider() {

				var container = document.getElementsByClassName('fullscreenSlider')[0];

				var slides = container.querySelectorAll('.fullscreenSlider__slide');

				var points = container.querySelectorAll('button');

				var slideIndex = 0;
				var loop;
				var longerAnimation = false;
				var timeout;

				function Loop() {

					loop = setInterval( 
						function(){

							if( longerAnimation ) {

								points.forEach( function( point, indexP ) {

									if( indexP == slideIndex ) {

										point.classList.add('activeLonger');

									} else {

										point.classList.remove('activeLonger');

									}

								});

								longerAnimation = false;

							} else {

								points.forEach( function( point, indexP ) {

									point.classList.remove('activeLonger');

								});

							}

							if( slideIndex >= slides.length ) {

								slideIndex = 0;

							}

							points.forEach( function( point, indexP ) {

								if( indexP == slideIndex ) {

									point.classList.add('active');

								} else {

									point.classList.remove('active');

								}

							});

							slides.forEach( function( slide , indexS ){

								if( indexS == slideIndex ) {

									slide.classList.add('active');

								} else {

									slide.classList.remove('active');

								}

							});

							slideIndex += 1;
							
						},4000 
					);

				};

				function StartLoop(time) {

					timeout = setTimeout(
						Loop()
						,time
					);

				};

				function StopLoop() {

					window.clearInterval( loop );
					loop = null;

				};

				points.forEach( function( point , indexP ) {

					point.addEventListener('click', function() {

						clearTimeout(timeout);
						longerAnimation = true;
						StopLoop();
						
						slideIndex = indexP;

						

						slides.forEach( function(slide, indexS) {

							if( indexS == indexP ) {

								slide.classList.add('active');

							} else {

								slide.classList.remove('active');

							}

						});

						points.forEach( function( point2, indexP2 ) {

							point2.classList.remove('active');
							point2.classList.remove('activeLonger');

						});

						StartLoop(4000);

					});

				});

				StartLoop(4000);

			}

			FullscreenSlider();
			
		}
    
	},
	finalize() {
    // JavaScript to be fired on the home page, after the init JS
	},
};
